export default __webpack_public_path__ + "static/media/aco.1d2664e4.png";